"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var BufferCaps_1 = require("./BufferCaps");
var SpatialOps = /** @class */ (function () {
    function SpatialOps() {
    }
    SpatialOps.buffer = function (geom, distance, quadrantSegments, endCapStyle) {
        if (quadrantSegments === void 0) { quadrantSegments = 8; }
        if (endCapStyle === void 0) { endCapStyle = BufferCaps_1.BufferCaps.default; }
        var tsGeom = geom._ts();
        var tsResult = tsGeom.buffer(distance, quadrantSegments, endCapStyle);
        return __1.GeometryFactory.create(tsResult);
    };
    SpatialOps.convexHull = function (geom) {
        var tsGeom = geom._ts();
        var tsResult = tsGeom.convexHull();
        return __1.GeometryFactory.create(tsResult);
    };
    SpatialOps.diff = function (geom1, geom2) {
        var tsGeom1 = geom1._ts();
        var tsGeom2 = geom2._ts();
        var result = tsGeom1.difference(tsGeom2);
        return __1.GeometryFactory.create(result);
    };
    SpatialOps.intersection = function (geom1, geom2) {
        var tsGeom1 = geom1._ts();
        var tsGeom2 = geom2._ts();
        var result = tsGeom1.intersection(tsGeom2);
        return __1.GeometryFactory.create(result);
    };
    SpatialOps.union = function (geom1, geom2) {
        var tsGeom1 = geom1._ts();
        var tsGeom2 = geom2._ts();
        var result = tsGeom1.union(tsGeom2);
        return __1.GeometryFactory.create(result);
    };
    SpatialOps.normalize = function (geom) {
        var tsGeom = geom._ts();
        var tsGeomNorm = tsGeom.norm();
        return __1.GeometryFactory.create(tsGeomNorm);
    };
    return SpatialOps;
}());
exports.SpatialOps = SpatialOps;
